<div
    class="select-wrapper"
    [ngClass]="{ 'fit-content': sizeToContent }"
    [class.disabled]="disabled || (!selectConfig.searchableOptions.length && !selectConfig.canDeselect)"
>
    <span class="hidden-width">{{ widestOption }}</span>
    <span class="caret-toggle" [ngClass]="selectConfig.size" (click)="openDropdown($event)">
        @if (!isLoading) {
            <i class="fa fa-angle-down"></i>
        } @else {
            <ws-ace-loader [inline]="true"></ws-ace-loader>
        }
    </span>
    <span class="input-result" [ngClass]="selectConfig.size" (click)="openDropdown($event)">
        @if (!selectedOption) {
            <span [title]="selectConfig.placeholder">{{ selectConfig.placeholder }}</span>
        }
        @if (selectedOption) {
            <span [title]="selectConfig.isPrimitive ? selectedOption : selectedOption[selectConfig.labelProperty]">
                @if (optionTemplate && !isResultPlainText) {
                    <ng-container
                        *ngTemplateOutlet="
                            optionTemplate;
                            context: { $implicit: selectedOption, label: getOptionLabel(selectedOption) }
                        "
                    ></ng-container>
                } @else {
                    {{ selectConfig.isPrimitive ? selectedOption : selectedOption[selectConfig.labelProperty] }}
                }
            </span>
        }
    </span>
    <ng-template #wsSelectDropdown></ng-template>
</div>
